(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bixdo-glossonic-pro-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-gpro-comparison]').forEach((root) => {
      if (root.dataset.gproComparisonReady === 'true') return;
      root.dataset.gproComparisonReady = 'true';
      const frame = root.querySelector('[data-gpro-comparison-frame]');
      const range = root.querySelector('[data-gpro-comparison-range]');
      if (!frame || !range) return;
      const update = () => frame.style.setProperty('--gpro-position', `${range.value}%`);
      range.addEventListener('input', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bixdo-glossonic-pro-consistency"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initConsistency = (root) => {
      if (!root || root.dataset.gproConsistencyReady === 'true') return;
      const tabs = Array.from(root.querySelectorAll('[data-gpro-consistency-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-gpro-consistency-panel]'));
      if (!tabs.length || !panels.length) return;

      root.dataset.gproConsistencyReady = 'true';
      let activeIndex = 0;
      let autoplayTimer;
      const autoplayEnabled = root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplayInterval = Math.max(Number(root.dataset.autoplayInterval) || 5000, 2000);
      const syncMediaRatio = (index) => {
        const image = panels[index] && panels[index].querySelector('img');
        if (!image) return;
        const setRatio = () => {
          if (image.naturalWidth > 0 && image.naturalHeight > 0) root.style.setProperty('--gpro-consistency-ratio', `${image.naturalWidth} / ${image.naturalHeight}`);
        };
        if (image.complete) setRatio();
        else image.addEventListener('load', setRatio, { once: true });
      };
      const stopAutoplay = () => window.clearTimeout(autoplayTimer);
      const scheduleAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || tabs.length < 2 || root.matches(':hover') || root.contains(document.activeElement)) return;
        autoplayTimer = window.setTimeout(() => {
          activate((activeIndex + 1) % tabs.length, false);
          scheduleAutoplay();
        }, autoplayInterval);
      };
      const activate = (index, moveFocus) => {
        const safeIndex = Math.max(0, Math.min(index, tabs.length - 1));
        activeIndex = safeIndex;
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === safeIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === safeIndex;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        syncMediaRatio(safeIndex);
        if (moveFocus) tabs[safeIndex].focus();
        scheduleAutoplay();
      };

      root.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-gpro-consistency-tab]');
        if (tab && root.contains(tab)) activate(Number(tab.dataset.index), false);
      });
      root.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-gpro-consistency-tab]');
        if (!tab || !root.contains(tab)) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); activate(Number(tab.dataset.index) + 1, true); }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); activate(Number(tab.dataset.index) - 1, true); }
        if (event.key === 'Home') { event.preventDefault(); activate(0, true); }
        if (event.key === 'End') { event.preventDefault(); activate(tabs.length - 1, true); }
      });
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', scheduleAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) scheduleAutoplay();
      });
      window.addEventListener('resize', () => syncMediaRatio(activeIndex), { passive: true });
      activate(0, false);
    };

    document.querySelectorAll('[data-gpro-consistency]').forEach(initConsistency);
    document.addEventListener('shopify:section:load', (event) => initConsistency(event.target.querySelector('[data-gpro-consistency]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bixdo-glossonic-pro-parameter-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const findRoot = (target) => {
      if (!(target instanceof Element)) return null;
      return target.matches('[data-gpro-parameter]') ? target : target.querySelector('[data-gpro-parameter]');
    };
    const mount = (root) => {
      if (!root || instances.has(root)) return;
      const scroll = root.querySelector('[role="region"]');
      const progress = root.querySelector('[data-gpro-parameter-progress]');
      if (!scroll || !progress) return;
      let frame = 0;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const maxScroll = scroll.scrollWidth - scroll.clientWidth;
          const value = maxScroll > 1 ? Math.min(1, Math.max(0, scroll.scrollLeft / maxScroll)) : 0;
          progress.style.setProperty('--gpro-parameter-progress', value.toFixed(4));
          progress.hidden = maxScroll <= 1;
        });
      };
      const cleanup = () => {
        cancelAnimationFrame(frame);
        scroll.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
      };
      scroll.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      instances.set(root, cleanup);
      update();
    };
    const unmount = (root) => {
      const cleanup = instances.get(root);
      if (!cleanup) return;
      cleanup();
      instances.delete(root);
    };
    const scan = (scope = document) => {
      if (scope.matches?.('[data-gpro-parameter]')) mount(scope);
      scope.querySelectorAll?.('[data-gpro-parameter]').forEach(mount);
    };
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = findRoot(event.target);
      if (root) unmount(root);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
    } else {
      scan();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bixdo-glossonic-system-preview-hero"] && !Shopify.designMode) return;
  try {
    
  // 维护说明：轮播脚本只管理当前 Section 内的 slide、箭头、圆点与自动播放。
  if (!customElements.get('glossonic-banner-carousel')) {
    customElements.define('glossonic-banner-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.gsb-slide'));
        this.track = this.querySelector('.gsb-track');
        this.dots = Array.from(this.querySelectorAll('.gsb-dots button'));
        this.index = 0;
        this.loop = this.dataset.loop === 'true';
        this.speed = Number(this.dataset.autoplaySpeed || 0);
        this.previousButton = this.querySelector('.gsb-arrow--prev');
        this.nextButton = this.querySelector('.gsb-arrow--next');
        if (this.slides.length < 2) return;
        this.previousButton?.addEventListener('click', () => this.show(this.index - 1, true));
        this.nextButton?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft') this.show(this.index - 1, true);
          if (event.key === 'ArrowRight') this.show(this.index + 1, true);
        });
        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
        }
        this.show(0, false);
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      show(nextIndex, userInitiated) {
        if (this.loop) nextIndex = (nextIndex + this.slides.length) % this.slides.length;
        else nextIndex = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
        this.index = nextIndex;
        if (this.dataset.transition === 'slide') this.track.style.transform = `translate3d(${-100 * nextIndex}%,0,0)`;
        this.slides.forEach((slide, index) => {
          const selected = index === nextIndex;
          slide.classList.toggle('is-selected', selected);
          slide.setAttribute('aria-hidden', String(!selected));
          slide.querySelectorAll('a').forEach(link => { link.tabIndex = selected ? 0 : -1; });
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === nextIndex)));
        if (this.previousButton) this.previousButton.disabled = !this.loop && nextIndex === 0;
        if (this.nextButton) this.nextButton.disabled = !this.loop && nextIndex === this.slides.length - 1;
        if (this.dataset.heightMode === 'adapt_image') {
          const slide = this.slides[nextIndex];
          this.style.setProperty('--gsb-ratio-d', slide.dataset.desktopRatio || '1.7778');
          this.style.setProperty('--gsb-ratio-m', slide.dataset.mobileRatio || slide.dataset.desktopRatio || '.75');
        }
        if (userInitiated) { this.stop(); this.start(); }
      }
      start() {
        if (this.speed <= 0 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = setInterval(() => {
          if (!this.loop && this.index === this.slides.length - 1) this.show(0, false);
          else this.show(this.index + 1, false);
        }, this.speed * 1000);
      }
      stop() { if (this.timer) clearInterval(this.timer); this.timer = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bixdo-glossonic-system-youtube"] && !Shopify.designMode) return;
  try {
    
  class BixdoYoutubeCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gs4-youtube__track');
      this.slides = Array.from(this.querySelectorAll('[data-youtube-slide]'));
      this.previous = this.querySelector('[data-youtube-prev]');
      this.next = this.querySelector('[data-youtube-next]');
      this.status = this.querySelector('[data-youtube-status]');
      this.dialog = this.querySelector('[data-youtube-dialog]');
      this.dialogFrame = this.querySelector('[data-youtube-dialog-frame]');
      this.dialogTitle = this.querySelector('[data-youtube-dialog-title]');
      this.closeButton = this.querySelector('[data-youtube-close]');
      this.querySelectorAll('[data-youtube-open]').forEach((button) => {
        button.addEventListener('click', () => this.openVideo(button));
      });
      this.closeButton?.addEventListener('click', () => this.closeVideo());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeVideo();
      });
      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeVideo();
      });
      if (!this.track || this.slides.length < 2) {
        this.querySelector('[data-youtube-controls]')?.setAttribute('hidden', 'hidden');
        return;
      }
      this.paused = false;
      this.update = this.update.bind(this);
      this.move = this.move.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.move(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.move(-1); }
      });
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.addEventListener('focusin', () => { this.paused = true; });
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.paused = false; });
      const interval = Number(this.dataset.autoplayInterval);
      if (interval > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = window.setInterval(() => { if (!this.paused && !document.hidden) this.move(1); }, interval);
      }
      this.update();
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    openVideo(button) {
      const id = button.dataset.videoId;
      const title = button.dataset.videoTitle || 'Glossonic video';
      if (!id || !this.dialog || !this.dialogFrame) return;
      this.dialogTitle.textContent = title;
      this.dialogFrame.title = title;
      this.dialogFrame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', 'open');
      this.closeButton.focus();
    }

    closeVideo() {
      if (!this.dialog) return;
      this.dialogFrame.src = '';
      if (this.dialog.open && typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
    }

    move(direction) {
      const current = this.currentIndex || 0;
      const nextIndex = (current + direction + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.slides[nextIndex].offsetLeft, behavior: 'smooth' });
      this.currentIndex = nextIndex;
      this.update();
    }

    update() {
      const viewportLeft = this.track.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Infinity;
      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - viewportLeft);
        if (distance < closestDistance) { closestDistance = distance; closestIndex = index; }
      });
      this.currentIndex = closestIndex;
      this.status.textContent = `${closestIndex + 1} / ${this.slides.length}`;
      this.previous.disabled = false;
      this.next.disabled = false;
    }
  }

  if (!customElements.get('bixdo-youtube-carousel')) customElements.define('bixdo-youtube-carousel', BixdoYoutubeCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bixdo-glossonic-system2"] && !Shopify.designMode) return;
  try {
    
(() => { document.querySelectorAll('.gs2-page').forEach((root) => { const menu = root.querySelector('.gs2-menu-toggle'); menu?.addEventListener('click', () => { root.classList.toggle('is-menu-open'); menu.setAttribute('aria-expanded', root.classList.contains('is-menu-open')); }); root.querySelectorAll('.gs2-thumb').forEach((thumb) => thumb.addEventListener('click', () => { const main = root.querySelector('[data-gs2-main-image]'); if (main) main.src = thumb.dataset.gs2Image; root.querySelectorAll('.gs2-thumb').forEach((item) => item.classList.remove('is-active')); thumb.classList.add('is-active'); })); root.querySelectorAll('.gs2-compare-visual').forEach((visual) => { const range = visual.querySelector('.gs2-compare-range'); const split = visual.querySelector('.gs2-compare-split'); const handle = visual.querySelector('.gs2-compare-handle'); const update = () => { if (!range || !split || !handle) return; split.style.width = range.value + '%'; handle.style.left = range.value + '%'; }; range?.addEventListener('input', update); update(); }); root.querySelectorAll('a[href^="#"]').forEach((link) => link.addEventListener('click', (event) => { const target = root.querySelector(link.getAttribute('href')); if (target) { event.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); } })); }); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bixdo-smile-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBixdoHero = (hero) => {
      if (!hero || hero.dataset.bixdoHeroReady === 'true') return;
      hero.dataset.bixdoHeroReady = 'true';
      const copy = hero.querySelector('.bixdo-hero__copy');
      const media = hero.querySelector('.bixdo-hero__media');
      const image = hero.querySelector('.bixdo-hero__image');
      if (!copy) return;

      let frameId;
      const measure = () => {
        cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(() => {
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const styles = getComputedStyle(hero);
          const baseHeight = parseFloat(styles.getPropertyValue(isMobile ? '--bs-hero-height-mobile' : '--bs-hero-height-desktop')) || (isMobile ? 650 : 620);
          const copyRect = copy.getBoundingClientRect();
          const heroRect = hero.getBoundingClientRect();
          const copyBottom = copyRect.bottom - heroRect.top;
          const copyBuffer = isMobile ? 36 : 56;
          let requiredHeight = copyBottom + copyBuffer;

          if (media && image && !media.classList.contains('bixdo-hero__media--cover') && image.complete && image.naturalWidth > 0) {
            const imageHeight = image.getBoundingClientRect().height;
            const imageBuffer = isMobile ? 28 : 48;
            requiredHeight = Math.max(requiredHeight, imageHeight + imageBuffer);
          }

          const nextHeight = Math.ceil(Math.max(baseHeight, requiredHeight));
          const currentHeight = parseFloat(styles.getPropertyValue('--bs-hero-auto-height')) || 0;
          if (Math.abs(nextHeight - currentHeight) > 1) {
            hero.style.setProperty('--bs-hero-auto-height', `${nextHeight}px`);
            measure();
          }
        });
      };

      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
      if (observer) {
        observer.observe(copy);
        if (image) observer.observe(image);
      }
      if (image) image.addEventListener('load', measure, { once: true });
      window.addEventListener('resize', measure, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      measure();
    };

    document.querySelectorAll('[data-bixdo-hero-section]').forEach(initBixdoHero);
    document.addEventListener('shopify:section:load', (event) => initBixdoHero(event.target.querySelector('[data-bixdo-hero-section]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bixdo-smile-join-paths"] && !Shopify.designMode) return;
  try {
    
  function initBixdoModeSection(root) {
    if (!root || root.dataset.bixdoModeReady === 'true') return;
    root.dataset.bixdoModeReady = 'true';
    const buttons = root.querySelectorAll('[data-mode-button]');
    const panels = root.querySelectorAll('[data-mode-panel]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const mode = button.dataset.modeButton;
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => {
          const active = panel.dataset.modePanel === mode;
          panel.hidden = !active;
        });
      });
    });
  }

  document.querySelectorAll('[data-bixdo-mode-section]').forEach(initBixdoModeSection);
  document.addEventListener('shopify:section:load', (event) => initBixdoModeSection(event.target.querySelector('[data-bixdo-mode-section]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bixdo-smile-requirements"] && !Shopify.designMode) return;
  try {
    
  function initBixdoFormatSection(root) {
    if (!root || root.dataset.bixdoFormatReady === 'true') return;
    root.dataset.bixdoFormatReady = 'true';
    const buttons = root.querySelectorAll('[data-format-button]');
    const panels = root.querySelectorAll('[data-format-panel]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const format = button.dataset.formatButton;
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.formatPanel !== format;
        });
      });
    });
  }

  document.querySelectorAll('[data-bixdo-format-section]').forEach(initBixdoFormatSection);
  document.addEventListener('shopify:section:load', (event) => initBixdoFormatSection(event.target.querySelector('[data-bixdo-format-section]')));

  } catch(e) { console.error(e); }
})();
})();
